import React from 'react';
import styles from './CookieBanner.module.css';

const consentKey = 'prismaops-cookie-consent';

export const CookieBanner: React.FC = () => {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    try {
      setVisible(window.localStorage.getItem(consentKey) !== 'accepted');
    } catch {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    try {
      window.localStorage.setItem(consentKey, 'accepted');
    } finally {
      setVisible(false);
    }
  };

  if (!visible) return null;

  return (
    <>
      <div className={styles.backdrop} aria-hidden="true" />
      <aside className={styles.banner} role="dialog" aria-modal="true" aria-labelledby="cookie-title">
        <div>
          <strong id="cookie-title">Privacy on this site</strong>
          <p>PrismaOps uses essential browser storage to remember your cookie choice. No advertising or tracking cookies are active.</p>
        </div>
        <button type="button" autoFocus onClick={acceptCookies} className={styles.button}>Continue</button>
      </aside>
    </>
  );
};
